/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import {selx} from 'clsx';

import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';

import type {QuerySamplingCta} from './';
import styles from './index.module.styl';

export function template(this: QuerySamplingCta) {
  const {t} = this.getContext(`i18n`);
  return (
    <div sel={selx(styles.mpQuerySamplingCta)}>
      <div sel='.mp-query-sampling-cta-title'>{t(`sampling.query-sampling.cta-header`)}</div>
      <ButtonEl on={{click: this.handleEnableQuerySampling}} attrs={{theme: ButtonTheme.Secondary, icon: `sampling`}}>
        {t(`sampling.query-sampling.cta-header`)}
      </ButtonEl>
    </div>
  );
}
